import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class OpacityAttribute extends AbstractBlock {
  constructor() {
    super('a-opacity', t.to('透明度', 'opacity'));
    this.setNameForCode('opacity');
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    ShapeSettings.setTitleField(block, this.title);

    const opacity = new Blockly.FieldTextInput('0.5');
    block
      .appendDummyInput()
      .appendField(t.to('0.0(透明)から1.0', 'opacity_label'))
      .appendField(opacity, 'opacity');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const opacity = CodeSetting.getFieldValue(block, 'opacity');
    const attribute = CodeSetting.getSubAttributeCode(block);

    // let str =   `opacity = '${opacity}' ` + attribute ;
    const str = CodeSetting.buildAttribute([['opacity', opacity],['transparent', 'true']]) + attribute;
    return [str];
  }
}
